import { Link } from 'react-router-dom'
import { PRIVACY_EMAIL } from '../legal/meta'
import { LegalLayout, LegalSection } from '../legal/LegalLayout'

export function Cookies() {
  return (
    <LegalLayout
      eyebrow="Legal sheet"
      title="Cookie notice"
      summary="How passwork.ae uses cookies and similar technologies, what is essential, what is optional, and how you can control them — read with our Privacy Policy."
      documentTitle="Cookie Notice | Passwork Software Solution"
      description="Cookie Notice for passwork.ae — essential and optional cookies, controls, and GDPR-oriented transparency."
    >
      <LegalSection code="K-01" title="What cookies are">
        <p>
          Cookies are small text files stored on your device. Similar
          technologies include local storage, pixels, and session identifiers.
          They help the site run, remember preferences, and — if you allow —
          understand aggregate usage.
        </p>
      </LegalSection>

      <LegalSection code="K-02" title="Who sets them">
        <p>
          First-party cookies are set by Passwork on passwork.ae. Third-party
          cookies may be set by providers we use for hosting analytics or
          fonts, only as described below and subject to your choices where
          required.
        </p>
      </LegalSection>

      <LegalSection code="K-03" title="Essential cookies">
        <p>
          Required for security, load balancing, consent storage, and basic
          navigation. These do not require consent under typical EU ePrivacy
          rules because the service cannot function without them. Examples:
          session continuity, CSRF protection tokens, and recording that you
          dismissed a notice.
        </p>
      </LegalSection>

      <LegalSection code="K-04" title="Analytics cookies">
        <p>
          If enabled, we may use privacy-respecting analytics to learn which
          pages are read (for example Compound vs home) in aggregate. These run
          only with consent where law requires it. Data is used to improve
          content structure, not to sell profiles.
        </p>
      </LegalSection>

      <LegalSection code="K-05" title="Marketing cookies">
        <p>
          We do not currently run third-party advertising networks on
          passwork.ae. If that changes, we will update this Notice and request
          consent before non-essential marketing cookies run.
        </p>
      </LegalSection>

      <LegalSection code="K-06" title="Duration">
        <p>
          Session cookies expire when you close the browser. Persistent cookies
          remain for a defined period (typically from a few days up to 13
          months for analytics, shorter for consent records refreshed on
          revisit). Exact lifetimes depend on the tool configuration at the
          time.
        </p>
      </LegalSection>

      <LegalSection code="K-07" title="Your controls">
        <p>
          You can refuse non-essential cookies via any banner we display, and
          you can clear or block cookies in your browser settings. Blocking
          essential cookies may break parts of the site. For broader data
          rights, see our{' '}
          <Link to="/privacy" className="index-link text-ink">
            Privacy Policy
          </Link>{' '}
          or email {PRIVACY_EMAIL}.
        </p>
      </LegalSection>

      <LegalSection code="K-08" title="Updates">
        <p>
          We will revise this Notice when our cookie stack changes materially.
          The effective date on the title sheet is the version in force.
        </p>
      </LegalSection>
    </LegalLayout>
  )
}
